import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaPanFiesta from './TablaPanFiesta';

const PanFiesta: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaPanFiesta />
    </Box>
  );
};

export default PanFiesta;
